import * as React from 'react';
import { hideOthers } from 'aria-hidden';
import { InteractivityDisabler } from "./InteractivityDisabler";
import { focusHiddenMarker } from "./medium";
var extractRef = function (ref) { return (('current' in ref) ? ref.current : ref); };
export function Effect(_a) {
    var setLockProps = _a.setLockProps, onEscapeKey = _a.onEscapeKey, onClickOutside = _a.onClickOutside, shards = _a.shards, onActivation = _a.onActivation, onDeactivation = _a.onDeactivation, noIsolation = _a.noIsolation;
    React.useEffect(function () {
        var _undo = function () {
            return;
        };
        var lastEventTarget;
        var onKeyPress = function (event) {
            if (event.defaultPrevented) {
                return;
            }
            if ((event.code === 'Escape' || event.key === 'Escape' || event.keyCode === 27) && onEscapeKey) {
                onEscapeKey(event);
            }
        };
        var onClick = function (event) {
            if (event.defaultPrevented || event.target === lastEventTarget) {
                return;
            }
            if (shards &&
                shards
                    .map(extractRef)
                    .some(function (node) { return node && node.contains(event.target) || node === event.target; })) {
                return;
            }
            if (onClickOutside) {
                onClickOutside();
            }
        };
        var onNodeActivation = function (node) {
            _undo = hideOthers([node].concat((shards || []).map(extractRef)), document.body, noIsolation ? undefined : focusHiddenMarker);
            if (onActivation) {
                onActivation(node);
            }
            document.addEventListener('keyup', onKeyPress);
            document.addEventListener('click', onClick);
            document.addEventListener('touchend', onClick);
        };
        var onNodeDeactivation = function () {
            _undo();
            if (onDeactivation) {
                onDeactivation();
            }
            document.removeEventListener('keyup', onKeyPress);
            document.removeEventListener('click', onClick);
            document.removeEventListener('touchend', onClick);
        };
        setLockProps({
            onClick: function (e) {
                lastEventTarget = e.target;
            },
            onTouchEnd: function (e) {
                lastEventTarget = e.target;
            },
            onActivation: onNodeActivation,
            onDeactivation: onNodeDeactivation,
        });
    }, []);
    return (React.createElement(InteractivityDisabler, null));
}
